// The public pages for what the app does that people search for by name (pages/localized/
// FeaturePromoPage.jsx). Each is one file here, loaded with its page only; this index says which
// route key shows which file, in one place, and the routes in i18n/routes.js use the same keys.
import { LANGUAGE_PAGE_CODES } from './languageRoutes.js';

export const FEATURE_PAGE_IDS = {
  'feature.scenes': 'scenes',
  'feature.srt': 'srt',
  'feature.cleanup': 'cleanup',
  'feature.voice': 'voice',
  'feature.translate': 'translate',
  'feature.characters': 'characters',
  'feature.remix': 'remix',
  'feature.fruit': 'fruit',
  'feature.polish': 'polish',
  'feature.story': 'story',
  'feature.free': 'free',
  'feature.podcasts': 'podcasts',
  'feature.streams': 'streams',
  'feature.ytshorts': 'ytshorts',
  'feature.clippers': 'clippers',
  'feature.interviews': 'interviews',
  'feature.lessons': 'lessons',
  'feature.clip-tools': 'clip-tools',
  'feature.longvideo': 'longvideo',
  'feature.clipchannel': 'clipchannel',
  'feature.dubclips': 'dubclips',
  'feature.opusalt': 'opusalt',
  'feature.klapalt': 'klapalt',
  'feature.bestmoments': 'bestmoments',
  'feature.permission': 'permission',
  'feature.captionlook': 'captionlook',
  'feature.agencies': 'agencies',
  'feature.talks': 'talks',
  'feature.agentchat': 'agentchat',
  'feature.drama': 'drama',
  'feature.voiceover': 'voiceover',
  'feature.originalclips': 'originalclips',
  'feature.historyclips': 'historyclips',
  'feature.lang-es': 'langSpanish',
  'feature.lang-ar': 'langArabic',
  // Saudi and Gulf Arabic, the dialect named in the idea (2026-10-30)
  'feature.lang-ar-gulf': 'langArabicGulf',
  // Kuwait and Qatar, a page each: the dialect, the money and the ideas of each (2026-10-30)
  'feature.gulf-kuwait': 'gulf-kuwait',
  'feature.gulf-qatar': 'gulf-qatar',
  // Bahrain and Oman, the same way (2026-10-30)
  'feature.gulf-bahrain': 'gulf-bahrain',
  'feature.gulf-oman': 'gulf-oman',
  // and the UAE (2026-10-30, lane AE): it had shared the Saudi page
  'feature.gulf-uae': 'gulf-uae',
  // Snapchat and TikTok ads for Gulf small businesses, Gulf Arabic only: a main page and four businesses (2026-10-30, lane AD)
  'feature.gulf-ads': 'gulf-ads',
  'feature.gulf-ads-cafe': 'gulf-ads-cafe',
  'feature.gulf-ads-perfume': 'gulf-ads-perfume',
  'feature.gulf-ads-abaya': 'gulf-ads-abaya',
  'feature.gulf-ads-store': 'gulf-ads-store',
  // one per other narration language, built from one set of facts (languages.js)
  ...Object.fromEntries(LANGUAGE_PAGE_CODES.map((code) => [`feature.lang-${code}`, `lang-${code}`])),
};

export const FEATURE_PAGE_LOADERS = {
  scenes: () => import('./scenes.js'),
  srt: () => import('./srt.js'),
  cleanup: () => import('./cleanup.js'),
  voice: () => import('./voice.js'),
  translate: () => import('./translate.js'),
  characters: () => import('./characters.js'),
  remix: () => import('./remix.js'),
  fruit: () => import('./fruit.js'),
  polish: () => import('./polish.js'),
  story: () => import('./story.js'),
  free: () => import('./free.js'),
  podcasts: () => import('./podcasts.js'),
  streams: () => import('./streams.js'),
  ytshorts: () => import('./ytshorts.js'),
  clippers: () => import('./clippers.js'),
  interviews: () => import('./interviews.js'),
  lessons: () => import('./lessons.js'),
  'clip-tools': () => import('./clip-tools.js'),
  longvideo: () => import('./longvideo.js'),
  clipchannel: () => import('./clipchannel.js'),
  dubclips: () => import('./dubclips.js'),
  opusalt: () => import('./opusalt.js'),
  klapalt: () => import('./klapalt.js'),
  bestmoments: () => import('./bestmoments.js'),
  permission: () => import('./permission.js'),
  captionlook: () => import('./captionlook.js'),
  agencies: () => import('./agencies.js'),
  talks: () => import('./talks.js'),
  agentchat: () => import('./agentchat.js'),
  drama: () => import('./drama.js'),
  voiceover: () => import('./voiceover.js'),
  originalclips: () => import('./originalclips.js'),
  historyclips: () => import('./historyclips.js'),
  langSpanish: () => import('./langSpanish.js'),
  langArabic: () => import('./langArabic.js'),
  langArabicGulf: () => import('./langArabicGulf.js'),
  'gulf-kuwait': () => import('./gulfCountries.js').then((m) => ({ default: m.gulfCountryPage('kuwait') })),
  'gulf-qatar': () => import('./gulfCountries.js').then((m) => ({ default: m.gulfCountryPage('qatar') })),
  'gulf-bahrain': () => import('./gulfCountries.js').then((m) => ({ default: m.gulfCountryPage('bahrain') })),
  'gulf-oman': () => import('./gulfCountries.js').then((m) => ({ default: m.gulfCountryPage('oman') })),
  'gulf-uae': () => import('./gulfCountries.js').then((m) => ({ default: m.gulfCountryPage('uae') })),
  ...Object.fromEntries(['main', 'cafe', 'perfume', 'abaya', 'store'].map((id) => [id === 'main' ? 'gulf-ads' : `gulf-ads-${id}`,
    () => import('./gulfAds.js').then((m) => ({ default: m.gulfAdPage(id) }))])),
  ...Object.fromEntries(LANGUAGE_PAGE_CODES.map((code) => [`lang-${code}`, () => import('./languages.js').then((m) => ({ default: m.languagePage(code) }))])),
};
